import { render, staticRenderFns } from "./MapPlotComments.vue?vue&type=template&id=24e3fc34&scoped=true&"
import script from "./MapPlotComments.vue?vue&type=script&lang=js&"
export * from "./MapPlotComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24e3fc34",
  null
  
)

export default component.exports